import {
  PayeeRequirement,
  RequirementStatus,
  SharedFileRequest,
  SharedFileRequestStatus
} from "@wingspanhq/wingspan-api-sdk";

import { selectorIsSharedFileNotNoneContext } from "./selectorIsSharedFileNotNoneContext";

export const selectorIsRequirementReadyToDownloadFile = (
  requirement: PayeeRequirement,
  sharedFile?: SharedFileRequest
): boolean => {
  return (
    !!sharedFile &&
    !!(selectorIsSharedFileNotNoneContext(sharedFile?.contextType)
      ? sharedFile.status !== SharedFileRequestStatus.PENDING_UPLOAD
      : sharedFile.fileId &&
        requirement.dataSourceId &&
        requirement.dataSourceStatus === RequirementStatus.COMPLETED)
  );
};
